import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Badge, Flex, Typography } from 'antd';

import dayjs from 'dayjs';

import { DATE_FORMAT } from '../../../constants/common';
import messages from '../../../constants/messages';

import { getEventsForNextThreeDays } from '../../../redux/actions/event';
import { getTasksForNextThreeDays } from '../../../redux/actions/task';

import LoadingBar from '../../../components/LoadingBar';
import { errorToastHandler } from '../../../components/action_notifier';

import EmptyPlaceholder from '../../ui-components/EmptyPlaceholder';

import styles from './styles.module.scss';

const { Text } = Typography;

function Events() {
  const dispatch = useDispatch();

  const { eventsForNextThreeDays: events } = useSelector(state => state.event);
  const { tasksForNextThreeDays: tasks } = useSelector(state => state.task);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    const today = dayjs().toISOString();
    const threeDaysLater = dayjs().add(3, 'days').endOf('day').toISOString();

    try {
      await Promise.all([
        dispatch(getEventsForNextThreeDays({ startDate: today, endDate: threeDaysLater })),
        dispatch(getTasksForNextThreeDays({ dueDate: threeDaysLater }))
      ]);
    } catch (error) {
      errorToastHandler(error?.response?.data?.message || messages.FAILED_ON_FETCH_DATA);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && <LoadingBar size="middle" />}
      {!loading && [...events, ...tasks]?.length > 0 ? (
        <Flex className="w-full" vertical={true} gap="small">
          {tasks?.map(item => (
            <Flex key={item.id} className="w-full" vertical={false} gap="small" justify="space-between">
              <Badge className={styles.badge} color={item.due_date ? '#3788d8' : '#51ae32'} text={item.title} />
              <Text type="secondary">{dayjs(item.due_date).format(DATE_FORMAT.DATE)}</Text>
            </Flex>
          ))}
          {events?.map(item => (
            <Flex key={item.id} className="w-full" vertical={false} gap="small" justify="space-between">
              <Badge className={styles.badge} color={item.due_date ? '#3788d8' : '#51ae32'} text={item.title} />
              <Text type="secondary">{dayjs(item.start_at).format(DATE_FORMAT.DATE)}</Text>
            </Flex>
          ))}
        </Flex>
      ) : (
        <EmptyPlaceholder description="You don't have any tasks or events in the next 3 days." />
      )}
    </>
  );
}

export default Events;
